import "./dashboardNav.css";
import { AiFillHome } from "react-icons/ai";
import { IoStatsChartSharp } from "react-icons/io5";
import { BsQrCodeScan } from "react-icons/bs";
import { BiSolidLeftArrow } from "react-icons/bi";
import { BiSolidRightArrow } from "react-icons/bi";
import { BiSolidLogOut } from "react-icons/bi";
import { useState } from "react";
import { Link } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";

const DashboardNav = () => {
  let [isToggled, setIsToggled] = useState<boolean>(false);
  const { user, logout } = UserAuth();

  return (
    <div className={`dashboardNav-${isToggled ? "inactive" : "active"}`}>
      <ul className="dashboardNav_menu">
        <li
          className="dashboardNav_menu_toggle"
          onClick={() => setIsToggled(!isToggled)}
        >
          {isToggled ? (
            <BiSolidRightArrow className="dashboardNav_menu_item_icon" />
          ) : (
            <BiSolidLeftArrow className="dashboardNav_menu_item_icon" />
          )}
        </li>

        <div className="dashboard_nav_menu_divider"></div>

        <Link className="no-text-decoration" to="/dashboard">
          <li className="dashboardNav_menu_item">
            <AiFillHome className="dashboardNav_menu_item_icon" />
            <span className="dashboardNav_menu_item_text">Dashboard</span>
          </li>
        </Link>

        <Link className="no-text-decoration" to="/dashboard/analytics">
          <li className="dashboardNav_menu_item">
            <IoStatsChartSharp className="dashboardNav_menu_item_icon" />
            <span className="dashboardNav_menu_item_text">Analytics</span>
          </li>
        </Link>

        <Link className="no-text-decoration" to="/dashboard/qrcodes">
          <li className="dashboardNav_menu_item">
            <BsQrCodeScan className="dashboardNav_menu_item_icon" />
            <span className="dashboardNav_menu_item_text">QR Codes</span>
          </li>
        </Link>

        <div className="dashboard_nav_menu_divider"></div>

        <Link
          className="no-text-decoration"
          to="/qrcodes"
          onClick={() => logout()}
        >
          <li className="dashboardNav_menu_item">
            <BiSolidLogOut className="dashboardNav_menu_item_icon" />
            <span className="dashboardNav_menu_item_text">Log Out</span>
          </li>
        </Link>
      </ul>
    </div>
  );
};

export default DashboardNav;
